import { PERIOD_ARTWORK_RANK } from '@/types/asset';

export enum CategoryKey {
  collection = 'collection',
  artwork = 'artwork',
}

export const CATEGORY_TABS = [
  {
    key: CategoryKey.artwork,
    text: 'Artworks',
  },
  // {
  //   key: CategoryKey.collection,
  //   text: 'Collections',
  // },
];

export const TIME_TABS = [
  {
    key: PERIOD_ARTWORK_RANK.hour,
    text: '1H',
  },
  // {
  //   key: PERIOD_ARTWORK_RANK.day,
  //   text: '1D',
  // },
  // {
  //   key: PERIOD_ARTWORK_RANK.week,
  //   text: '7D',
  // },
  // {
  //   key: PERIOD_ARTWORK_RANK.month,
  //   text: '30D',
  // },
];

export enum RANK_COLUMNS_ID {
  ORDER = 'order',
  ARTWORK = 'artwork',
  PRICE = 'price',
  VOLUME = 'volume',
}

export const RANK_COLUMNS = [
  { id: RANK_COLUMNS_ID.ORDER, title: 'Rank' },
  { id: RANK_COLUMNS_ID.ARTWORK, title: 'Artwork' },
  { id: RANK_COLUMNS_ID.PRICE, title: 'Floor price' },
  { id: RANK_COLUMNS_ID.VOLUME, title: 'Volume' },
];
